import React from 'react'
import Header from '../component/Header'
import Footer from '../component/Footer'
import { Col, Container, Row } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import LeftArrow from '../assets/images/left-arrow.svg'
function HelpList() {
  const navigate = useNavigate()
   const helpCategories = [
    {
      title: 'Rental Applications',
      links: [
        'Portable Applications FAQs',
        'General Questions',
        'Set up & Payment',
        'Screening Reports',
        'Conditional Approval FAQs'
      ]
    },
    {
      title: 'Listing a Property',
      links: [
        'Real Estate Rental Manager Account Verification',
        'About Real Estate Rental Manager',
        'Creating a Listing',
        'Managing Your Listings',
        'Uploading Photos',
        'Listing Decline Reasons'
      ]
    },
    {
      title: 'Multifamily & Existing Feeds',
      links: [
        'Sharing Fee Data with Real Estate',
        'Rent Manager Integration FAQs',
        'LeaseStar (RealPage) Integration FAQs',
        'ResMan Integration FAQs',
        'AppFolio Integration FAQs',
        'Multifamily & New Feeds'
      ]
    },
    {
      title: 'Online Leases',
      links: [
        'Creating a New Lease',
        'Uploading an Existing Lease',
        'Managing a Lease',
        'Signing a Lease',
        'Sharing and reviewing a lease',
        'Property Condition Report FAQs'
      ]
    },
    {
      title: 'Online Rent Payments',
      links: [
        'General Information',
        'Updating your Payments',
        'Payment Set Up',
        'Rent Reporting to Credit Bureaus'
      ]
    },
    {
      title: 'General FAQs',
      links: [
        "Why Aren't My Rental Listings Syndicating onto Real Estate?"
      ]
    },
    {
      title: 'General HelpRental Protection (AZ, CO, NC, TX, OH) | Real Estate Insurance Services (Discontinued)',
      links: [
        'Discontinuing Rental Protection',
        'General Information',
        'Deposits with Rental Protection',
        'End of Coverage Period',
        'Rental Protection Coverage',
        'Lease Terms and Rental Protection Coverage'
      ]
    }
  ]

  return (
    <>
      <div className='main help-page'>
        <Header/>
        <section className="help-list-section common-padding">
          <Container>
            <div className="help-header">
              <button className="back-button" onClick={() => navigate(-1)}>
                <img src={LeftArrow} alt="Back" />
              </button>
              <div className="header-content">
                <h1>Landlords</h1>
                <p className="subtitle">Access comprehensive guides and support resources designed specifically for landlords navigating the real estate market.</p>
              </div>
            </div>
            <Row>
              {helpCategories.map((category, index) => (
                <Col lg={6} md={6} sm={12} key={index}>
                  <div className="help-category">
                    <div className="category-header">
                       <h3>{category.title}</h3>
                    </div>
                    <ul className="help-links">
                      {category.links.map((link, linkIndex) => (
                        <li key={linkIndex}>
                          <Link to={`/help-detail`}>
                            {link}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </>
  )
}
export default HelpList


